module.exports = __webpack_public_path__ + "static/media/Group882.6c2c5a98.svg";